<template>
  <el-container class="home-wrap">
    <el-main class="full-content buy-table">
      <div class="flex-row-center buy-header buy_header_about">
        {{$t('About')}}
      </div>
      <div class="flex-col-center buy-main">
        <img :src="$Image('abt_logo.png')" alt="">
        <div class="buy-main-choose">{{$t('FamiKit V1.0.0')}}</div>
        <a style="text-decoration:underline;cursor:pointer;" @click="Useragreement">{{$t('User agreement')}}</a>
        <a style="text-decoration:underline;cursor:pointer;" @click="Userprivacy">{{$t('User privacy agreement')}}</a>
      </div>
      <div class="flex-row-center buy-footer buy_footer_about">
        <el-button @click="Return" class="normalBtn buy-footer-btn">{{$t('Return')}}
        </el-button>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'About',
  props: ['userid', 'device'],
  data () {
    return {
    }
  },
  methods: {
    Useragreement () {
      window.open('https://famikit.com/terms.html')
    },
    Userprivacy () {
      window.open('https://famikit.com/privacy.html')
    },
    Return () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.home-wrap{
  width:100%;
  height:90%;
  box-sizing: border-box;
  .buy-table{
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    height: 100%;
    .buy-header{
      width:100%;
      height:9%;
      box-sizing: border-box;
      border-bottom:1px solid #e5e5e5;
      color: #333333;
      font-size: 24px;
    }
    .buy-footer{
      width:100%;
      height:9%;
      border-top:1px solid #e5e5e5;
      padding:15px 0;
      .buy-footer-btn{
        height: 50px;
        width: 191px;
        font-size:20px;
     }
    }
    .buy-main{
      width: 100%;
      height: 75%;
      a {
        font-size: 18px;line-height: 36px;letter-spacing: 0px;color: #2bcf88;
      }
      .buy-main-choose{
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        padding: 4% 0;
        color: #333333;
      }
    }
  }
}
@media (max-width: 1024px){
  .home-wrap .buy-table .buy_header_about, .home-wrap .buy-table .buy_footer_about{
    display: none;
  }
}
@media (max-width: 414px){
  .buy-footer-btn {
    height: 40px;
    width: 130px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue